<template>
  <solution-sheet-item :title="title">
    <solution-sheet-sub-item :title="$t('Min')">
      <p class="solution_sheet__item__val" v-if="hasCantilever">
        C1: {{ loadMinCantileverSpansValue[0] }}kN
      </p>

      <p
        class="solution_sheet__item__val"
        v-for="(solution_sheet__item, i) in loadMinMainSpansValue"
        :key="'min' + i"
      >
        V{{ i + 1 }}: {{ loadMinMainSpansValue[i] }}kN
      </p>

      <p class="solution_sheet__item__val" v-if="hasCantilever">
        C2: {{ loadMinCantileverSpansValue[1] }}kN
      </p>
    </solution-sheet-sub-item>

    <solution-sheet-sub-item :title="$t('Max')" v-if="hasMaxValue">
      <p class="solution_sheet__item__val" v-if="hasCantilever">
        C1: {{ loadMaxCantileverSpansValue[0] }}kN
      </p>

      <p
        class="solution_sheet__item__val"
        v-for="(solution_sheet__item, i) in loadMaxMainSpansValue"
        :key="'max' + i"
      >
        V{{ i + 1 }}: {{ loadMaxMainSpansValue[i] }}kN
      </p>

      <p class="solution_sheet__item__val" v-if="hasCantilever">
        C2: {{ loadMaxCantileverSpansValue[1] }}kN
      </p>
    </solution-sheet-sub-item>

    <template slot="illustration">
      <calc-illustration which="genericLoad" :is-span-by-span="isSpanBySpan" />
    </template>
  </solution-sheet-item>
</template>

<script>
import { lastOf } from "@/utils";
import { withoutDuplicates } from "@/utils";
import {
  SolutionSheetItem,
  SolutionSheetSubItem,
  CalcIllustration,
} from "@/components";

export default {
  components: {
    CalcIllustration,
    SolutionSheetItem,
    SolutionSheetSubItem,
  },
  props: {
    title: {
      required: true,
      type: String,
      default: "Item title not defined",
    },
    loadMinValue: {
      required: true,
      type: Array,
    },
    loadMaxValue: {
      required: true,
      type: Array,
    },
    hasCantilever: {
      required: true,
      type: Boolean,
    },
  },

  computed: {
    isSpanBySpan() {
      return withoutDuplicates(this.loadMinValue).length !== 1;
    },

    hasMaxValue() {
      return (
        withoutDuplicates(this.loadMaxValue).length !== 1 ||
        this.loadMaxValue[0] !== 0
      );
    },

    loadMinMainSpansValue() {
      if (this.hasCantilever) {
        return this.loadMinValue.slice(1, -1);
      } else {
        return [...this.loadMinValue];
      }
    },

    loadMinCantileverSpansValue() {
      if (this.hasCantilever) {
        return [this.loadMinValue[0], lastOf(this.loadMinValue)];
      } else {
        return null;
      }
    },

    loadMaxMainSpansValue() {
      if (!this.hasMaxValue) return null;

      if (this.hasCantilever) {
        return this.loadMaxValue.slice(1, -1);
      } else {
        return [...this.loadMaxValue];
      }
    },

    loadMaxCantileverSpansValue() {
      if (!this.hasMaxValue) return null;

      if (this.hasCantilever) {
        return [this.loadMaxValue[0], lastOf(this.loadMaxValue)];
      } else {
        return null;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
